export * from "./physician.service";



// WEBPACK FOOTER //
// ./src/app/shared/services/physician/index.ts